import request from '@/services/request'

export default {
  /**
   * 获取仓库列表
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchFbaInventoryList: (data, options = {}) => {
    return request(
      {
        url: '/inventory/getInventoryList',
        method: 'post',
        desc: '获取fba列表'
      },
      data,
      options
    )
  },
}
